import type { NDateLocale } from './enUS'
import { nl } from 'date-fns/locale'

const dateNlNL: NDateLocale = {
  name: 'nl-NL',
  locale: nl
}

export default dateNlNL
